import { LOGGED_OUT } from 'actions/types';
import { SET_UP_STRIPE_INTENT_CONFIRM_SUCCESS } from 'features/premium/actions/types';
export const initialState = {
    invites: [],
    rejectedInvites: [],
    extraMembersInfo: null,
    isCancellingOrAutoRenewing: false,
    suggestFrom: undefined,
};
const PAYMENT_CLEARED_GRACE_PERIOD_MS = 30_000;
const preserveSeatPaymentCleared = (state, extraMembersInfo) => {
    const isWithinGracePeriod = state.seatPaymentFailedClearedAt != null &&
        Date.now() - state.seatPaymentFailedClearedAt <
            PAYMENT_CLEARED_GRACE_PERIOD_MS;
    if (isWithinGracePeriod && extraMembersInfo?.paymentFailed) {
        return {
            extraMembersInfo: { ...extraMembersInfo, paymentFailed: null },
        };
    }
    if (isWithinGracePeriod && !extraMembersInfo?.paymentFailed) {
        return { extraMembersInfo, seatPaymentFailedClearedAt: null };
    }
    return { extraMembersInfo };
};
const sharedPlans = (state = initialState, action) => {
    switch (action.type) {
        case LOGGED_OUT: {
            return initialState;
        }
        case 'REMOVE_EXTRA_MEMBER_CANCELLED_INVITE': {
            return {
                ...state,
                rejectedInvites: state.rejectedInvites.filter((invite) => invite.id !== action.id),
            };
        }
        case 'CANCEL_EXTRA_MEMBER_SLOT_REQUEST':
        case 'ENABLE_AUTO_RENEW_FOR_EXTRA_MEMBER_REQUEST': {
            return {
                ...state,
                isCancellingOrAutoRenewing: true,
            };
        }
        case 'CANCEL_EXTRA_MEMBER_SLOT_FAILURE':
        case 'ENABLE_AUTO_RENEW_FOR_EXTRA_MEMBER_FAILURE': {
            return {
                ...state,
                isCancellingOrAutoRenewing: false,
            };
        }
        case 'CANCEL_EXTRA_MEMBER_SLOT_SUCCESS':
        case 'ENABLE_AUTO_RENEW_FOR_EXTRA_MEMBER_SUCCESS': {
            return {
                ...state,
                isCancellingOrAutoRenewing: false,
                extraMembersInfo: action.payload.extraMembersInfo,
            };
        }
        case 'PURCHASE_EXTRA_MEMBER_SLOTS_REQUEST': {
            if (action.extra.isAutoRenewingOrCancelling) {
                return {
                    ...state,
                    isCancellingOrAutoRenewing: true,
                };
            }
            return state;
        }
        case 'PURCHASE_EXTRA_MEMBER_SLOTS_FAILURE': {
            if (action.extra.isAutoRenewingOrCancelling) {
                return {
                    ...state,
                    isCancellingOrAutoRenewing: false,
                };
            }
            return state;
        }
        case 'PURCHASE_EXTRA_MEMBER_SLOTS_SUCCESS': {
            if (action.extra.isAutoRenewingOrCancelling) {
                return {
                    ...state,
                    isCancellingOrAutoRenewing: false,
                    extraMembersInfo: action.payload.extraMembersInfo,
                };
            }
            return {
                ...state,
                extraMembersInfo: action.payload.extraMembersInfo,
            };
        }
        case 'GET_SHARED_PLANS_SUCCESS': {
            return {
                ...state,
                ...preserveSeatPaymentCleared(state, action.payload.extraMembersInfo),
            };
        }
        case 'REMOVE_EXTRA_MEMBER_SUCCESS': {
            return {
                ...state,
                extraMembersInfo: action.payload.extraMembersInfo,
            };
        }
        case 'INVITE_TO_EXTRA_MEMBER_SLOT_SUCCESS': {
            return {
                ...state,
                rejectedInvites: state.rejectedInvites.filter((rejectedInvites) => !!rejectedInvites.handle &&
                    !action.extra.handles.includes(rejectedInvites.handle)),
                extraMembersInfo: action.payload.extraMembersInfo,
            };
        }
        case 'GET_EXTRA_MEMBER_INVITE_REQUESTS_SUCCESS': {
            return {
                ...state,
                invites: state.invites.length
                    ? [...state.invites, ...action.payload.invites]
                    : action.payload.invites,
            };
        }
        case 'CLEAR_EXTRA_MEMBER_INVITES': {
            return {
                ...state,
                invites: [],
            };
        }
        case 'REJECT_EXTRA_MEMBER_INVITE_FROM_LINK_SUCCESS':
        case 'REJECT_EXTRA_MEMBER_INVITE_SUCCESS': {
            return {
                ...state,
                invites: action.payload.invites || [],
            };
        }
        case 'GET_EXTRA_MEMBER_INVITE_LINK_INFO_SUCCESS': {
            return {
                ...state,
                invites: state.invites.length
                    ? [
                        ...state.invites,
                        { ...action.payload.invite, uuid: action.extra.uuid },
                    ]
                    : [{ ...action.payload.invite, uuid: action.extra.uuid }],
            };
        }
        case 'GET_EXTRA_MEMBER_CANCELLED_INVITES_SUCCESS': {
            return {
                ...state,
                rejectedInvites: action.payload.invites,
            };
        }
        case 'SET_SUGGEST_FROM': {
            return {
                ...state,
                suggestFrom: action.suggestFrom,
            };
        }
        case 'CLEAR_SUGGEST_FROM': {
            return {
                ...state,
                suggestFrom: undefined,
            };
        }
        case 'CLEAR_STRIPE_SEAT_BASED_FAILED_PAYMENT':
        case SET_UP_STRIPE_INTENT_CONFIRM_SUCCESS: {
            if (!state.extraMembersInfo)
                return state;
            return {
                ...state,
                seatPaymentFailedClearedAt: Date.now(),
                extraMembersInfo: {
                    ...state.extraMembersInfo,
                    paymentFailed: null,
                },
            };
        }
        default: {
            return state;
        }
    }
};
export default sharedPlans;
